import {Documents, EfeResponse, UploadDocumentServiceRequest} from 'commons/models';
import EfeApi from 'services/api/Api';

async function getDocument(
    documentKey: string,
    extension = 'pdf'
): Promise<EfeResponse<Documents>> {
    try {
        return await EfeApi.Documents.get<Documents>('/api/v1/documents/download', {
            params: {documentKey: documentKey},
            responseType: 'arraybuffer',
        }).then((res) => {
            return Promise.resolve({
                data: {data: res.data, filename: `${documentKey}.${extension}`},
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function updateDocument(request: UploadDocumentServiceRequest): Promise<EfeResponse<any>> {
    try {
        const formData = new FormData();
        formData.append('file', request.file, request.filename);
        formData.append('documentKey', request.documentKey);
        formData.append('expedientId', request.expedientId.toString());
        formData.append('kycId', request.kycId.toString());
        return await EfeApi.Documents.put<any>('/api/v1/documents/upload', formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
        }).then((res) => {
            return Promise.resolve({
                data: {},
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function getDocumentByKycId(
    documentKey: string,
    expedientId: number,
    kycId: number,
    extension = 'png'
): Promise<EfeResponse<Documents>> {
    try {
        return await EfeApi.Documents.get<Documents>('/api/v1/documents/personal/docs', {
            params: {documentKey: documentKey, expedientId: expedientId, kycId: kycId},
            responseType: 'blob',
        }).then(async (res) => {
            return Promise.resolve({
                data: {data: res.data, filename: `${documentKey}.${extension}`},
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        console.error(error);
        return Promise.reject(error);
    }
}

export default {
    getDocument,
    updateDocument,
    getDocumentByKycId,
};
